module.exports = __webpack_public_path__ + "static/media/logo-web-branco.7727c216.svg";